import { gql } from '@apollo/client'

import ProductSpecificationFragment from '@Queries/cms/fragments/ProductSpecification.fragment'

export default gql`
    ${ProductSpecificationFragment}
    
  fragment ProductBundle on Attribute {
    ... on ProductsWithQuantityAttribute {
      products: productsWithQuantity {
        quantity
        productID
        product {
          id
          name
          type
          url
          image: asset(tag: "primary") {
            url
            dimensions {
              width
              height
            }
          }
          ...ProductSpecificationFragment
          masterVariant {
            id
            price {
              ...PriceFragment
            }
          }
        }
      }
    }
  }
`
